export enum QuantitiesTypes {
  Depth = 'depth',
  Diameters = 'diameters',
  Density = 'density',
  ROP = 'forecastRop',
  Duration = 'forecastDuration',
  Angles = 'angles',
  Distance = 'distance',
  Location = 'location',
  Volume = 'volume',
}

export const defaultUnits = new Map<QuantitiesTypes, string>([
  [QuantitiesTypes.Depth, 'm'],
  [QuantitiesTypes.Diameters, 'in'],
  [QuantitiesTypes.Density, 'sg'],
  [QuantitiesTypes.ROP, 'm/h'],
  [QuantitiesTypes.Duration, 'h'],
  [QuantitiesTypes.Angles, 'deg'],
  [QuantitiesTypes.Distance, 'm'],
  [QuantitiesTypes.Location, 'm'],
  [QuantitiesTypes.Volume, 'm3'],
]);
